import React, { useEffect, useRef, useState } from 'react';
import { Table, message } from 'antd';
import { tableColumns } from './utils/config';
import './InitialDetailInfo.scss';
import { VehicleInitialDetailFetch } from './utils/fetch';
import { HttpStatusCode } from '@/fetch/core/constant';
import { BootStatus } from './utils/constant';
import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { formateTime } from './utils/constant';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import moment from 'moment';

const InitialDetailInfo = ({ vehicleName }: { vehicleName: string }) => {
  const fetchApi = new VehicleInitialDetailFetch();
  let timer: any = null;
  let timeClock: any = null;

  function formateData(arr: any, nodeName: 'Compute' | 'Control') {
    const infoList: any[] = [];
    Array.isArray(arr) &&
      arr.length >= 0 &&
      arr?.forEach((item: any) => {
        if (item.bootStatus !== 'WAIT_START') {
          infoList.push({
            nodeName: nodeName,
            name: item.name,
            status: item.bootStatus,
            startTime: item.startTime,
            endTime: item.endTime,
            principal: '',
            logDetails:
              item.errorCode || item.errorMsg
                ? `${item.errorCode},${item.errorMsg}`
                : '-',
          });
        }
      });
    return infoList;
  }

  const formateInfo = (list: any[]) => {
    const info: any = {};
    const roverStartMap: any = new Map([
      [0, { key: 'firstRover', value: [] }],
      [1, { key: 'secondRover', value: [] }],
      [2, { key: 'thirdRover', value: [] }],
      [3, { key: 'fourthRover', value: [] }],
      [-1, { key: 'hardwareModule', value: [] }],
    ]);

    list.forEach((item: any) => {
      if (item.hardwareModule) {
        const h = formateData(
          item.hardwareModule?.moduleBootDetailList,
          item.nodeName,
        );
        roverStartMap.get(-1).value = roverStartMap.get(-1).value.concat(h);
      }
      if (item.moduleBootList) {
        item.moduleBootList?.forEach((module: any, index: number) => {
          const r = formateData(module?.moduleBootDetailList, item.nodeName);
          roverStartMap.get(index).value = roverStartMap
            .get(index)
            .value.concat(r);
        });
      }
    });

    for (const item of roverStartMap.values()) {
      info[item.key] = item.value;
    }
    return info;
  };
  const [currentSelectedTab, setCurrentSelectedTab] = useState<string>('');
  const [startUpInfo, setStartUpInfo] = useState<any>({
    hardwareModule: [],
    firstRover: [],
    secondRover: [],
    thirdRover: [],
    fourthRover: [],
  });
  const [tabList, setTabList] = useState<any[]>([
    {
      label: '开机准备',
      value: 'hardwareModule',
    },
    {
      label: 'ROVER启动第1次',
      value: 'firstRover',
    },
    {
      label: 'ROVER启动第2次',
      value: 'secondRover',
    },
    {
      label: 'ROVER启动第3次',
      value: 'thirdRover',
    },
    {
      label: 'ROVER启动第4次',
      value: 'fourthRover',
    },
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const initialTime = useRef<any>({
    startTime: null,
    endTime: null,
  });
  const common = useSelector((state: RootState) => state.common);
  const { vehicleStartUpEnum } = common;

  const renderStatusIcon = (status: BootStatus) => {
    switch (status) {
      case BootStatus.STARTING:
        return (
          <span className='icon-starting'>
            <LoadingOutlined />
          </span>
        );
      case BootStatus.START_SUCCESS:
        return (
          <span className='icon-success'>
            <CheckOutlined />
          </span>
        );
      case BootStatus.START_FAILED:
        return (
          <span className='icon-failed'>
            <CloseOutlined />
          </span>
        );
      case BootStatus.SHUT_DOWN_SUCCESS:
        return (
          <span className='icon-failed'>
            <CloseOutlined />
          </span>
        );
      case BootStatus.NO_STATUS:
        return null;
    }
  };
  const [, forceUpdate] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    fetchDetailInfo().then((res: any) => {
      setCurrentSelectedTab(res[res?.length - 1].value);
    });
    timer = setInterval(() => {
      fetchDetailInfo();
    }, 5000);

    return () => {
      timer && clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    timeClock = setInterval(() => {
      forceUpdate(Date.now());
    }, 1000);

    return () => {
      timeClock && clearInterval(timeClock);
    };
  }, []);

  const fetchDetailInfo = async () => {
    let maxTabLength;
    try {
      const res = await fetchApi.getDetail({
        vehicleName: vehicleName,
      });
      if (res && res.code === HttpStatusCode.Success) {
        // 初始化耗时
        initialTime.current = {
          startTime: res.data?.startTime,
          endTime: res.data?.endTime,
        };

        // 组合tab标签
        maxTabLength = Math.max(
          res.data?.nodeBootList[0]?.moduleBootList?.length + 1 || 1,
          res.data?.nodeBootList[1]?.moduleBootList?.length + 1 || 1,
        );
        setTabList(tabList.slice(0, maxTabLength));

        // 处理数据
        if (res.data?.nodeBootList) {
          setStartUpInfo(formateInfo(res.data?.nodeBootList));
        }

        // 失败或成功后改为10s一轮询
        if (
          res.data?.allBootStatus === BootStatus.START_FAILED ||
          res.data?.allBootStatus === BootStatus.START_SUCCESS
        ) {
          clearInterval(timer);
          timer = setInterval(() => {
            fetchDetailInfo();
          }, 10000);
        } else {
          clearInterval(timer);
          timer = setInterval(() => {
            fetchDetailInfo();
          }, 5000);
        }

        // 成功或失败后就有结束时间了，不再更新初始化时间
        if (res.data?.endTime) {
          clearInterval(timeClock);
        }
      } else {
        clearInterval(timer);
        clearInterval(timeClock);
        message.error(res.message || '接口请求报错');
        maxTabLength = 0;
      }
      return tabList.slice(0, maxTabLength);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const formateColumns = () => {
    return tableColumns.map((col: any) => {
      switch (col.dataIndex) {
        case 'moduleInfo':
          return {
            ...col,
            render: (params: any, record: any, index: any) => {
              return `【${record.nodeName}】${
                vehicleStartUpEnum.get(record.nodeName + record.name)
                  ?.moduleFieldName ?? record.name
              }`;
            },
          };
        case 'status':
          return {
            ...col,
            render: (params: any, record: any, index: any) => {
              return renderStatusIcon(record.status);
            },
          };
        case 'duration':
          return {
            ...col,
            render: (params: any, record: any, index: any) => {
              const durationTime: any = formateTime(
                record.startTime,
                record.endTime,
                false,
              );
              return (
                <span
                  className={
                    durationTime.totalSeconds >
                    vehicleStartUpEnum.get(record.nodeName + record.name)
                      ?.overtimeThreshold
                      ? 'delay'
                      : 'notdelay'
                  }
                >
                  {durationTime.time}
                </span>
              );
            },
          };
        case 'principal':
          return {
            ...col,
            render: (params: any, record: any, index: any) => {
              return (
                vehicleStartUpEnum.get(record.nodeName + record.name)
                  ?.principalErps ?? '-'
              );
            },
          };
        default:
          return {
            ...col,
            render: (text: any) => `${text || '-'}`,
          };
      }
    });
  };

  const renderTab = () => {
    return tabList.map((item: any, index: number) => {
      let tabStatus: BootStatus;
      let startingList = startUpInfo[item.value]?.filter((item: any) => {
        return item.status === BootStatus.STARTING;
      });
      let failedList =
        item.value != 'hardwareModule' &&
        startUpInfo[item.value]?.filter((item: any) => {
          return (
            item.status === BootStatus.START_FAILED ||
            BootStatus.SHUT_DOWN_SUCCESS
          );
        });
      let successList = startUpInfo[item.value]?.filter((item: any) => {
        return item.status === BootStatus.START_SUCCESS;
      });

      if (startingList.length > 0) {
        tabStatus = BootStatus.STARTING;
      } else if (failedList.length > 0) {
        tabStatus = BootStatus.START_FAILED;
      } else if (
        successList.length === startUpInfo.length ||
        item.value == 'hardwareModule'
      ) {
        tabStatus = BootStatus.START_SUCCESS;
      } else {
        tabStatus = BootStatus.NO_STATUS;
      }

      return (
        <div
          className='tabItem'
          key={item.value}
          onClick={() => {
            setCurrentSelectedTab(item.value);
          }}
        >
          <span
            className={
              item.value === currentSelectedTab ? 'selected' : 'unSelected'
            }
          >
            {item.label}
          </span>
          {renderStatusIcon(tabStatus)}
        </div>
      );
    });
  };

  return (
    <div className='initialDetailInfo'>
      {Object.values(startUpInfo).flat(1)?.length > 0 ? (
        <>
          <div className='leftContainer'>
            <div className='tabContainer'>{renderTab()}</div>
            <div className='timeContainer'>
              <span>车辆开机时间：</span>
              <br />
              <span>
                {moment(
                  Math.round(initialTime.current.startTime / 1000000),
                ).format('YYYY-MM-DD HH:mm:ss')}
              </span>
            </div>
            <div className='timeContainer'>
              <span>初始化用时：</span>
              <br />
              <span>
                {formateTime(
                  initialTime.current.startTime,
                  initialTime.current.endTime,
                  true,
                ).toString()}
              </span>
            </div>
          </div>
          <div className='rightContainer'>
            <Table
              rowKey={(record) => record.nodeName + record.name}
              columns={formateColumns()}
              scroll={{
                y: 510,
              }}
              bordered={true}
              pagination={false}
              loading={loading}
              dataSource={startUpInfo[currentSelectedTab] ?? []}
            />
          </div>
        </>
      ) : (
        <div className='noData'>{'暂无数据'}</div>
      )}
    </div>
  );
};

export default React.memo(InitialDetailInfo);
